module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_5.06ac4688.png";